import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from '@material-ui/core';
import { css } from '@emotion/react';
import NavResponsiveModal, { ModalHeader } from '@/components/Navigation/NavResponsiveModal';
import { ModalContent, GreyBody } from '@/styles/blocks';
import { DETAILS_TABS } from './constants';

// Generic account-details modal. `context` selects which tab components render (only SHIPPER
// is populated today; Network Carriers / Flex Centers can add their own tabs later).
const AccountDetailsModal = ({ open, onClose, context = 'SHIPPER', clientId, clientName }) => {
    const tabs = DETAILS_TABS[context] || [];
    const [tabIndex, setTabIndex] = useState(0);
    // State outlives a single open, so a stale index can exceed a narrower context's tab count.
    const safeIndex = Math.min(tabIndex, Math.max(tabs.length - 1, 0));
    const active = tabs[safeIndex];
    const ActiveComponent = active?.Component;

    // This instance is mounted for the page, not per account — start each open on the first tab.
    useEffect(() => {
        if (open) setTabIndex(0);
    }, [open]);

    return (
        <NavResponsiveModal open={open} onClose={onClose} maxWidth="md" fullWidth>
            <ModalHeader
                title={`Details${clientName ? ` — ${clientName}` : ''}`}
                onClose={onClose}
                css={css`
                    border-bottom: 1px solid lightgray;
                `}
            />
            <ModalContent
                css={css`
                    width: 100%;
                `}
            >
                {tabs.length === 0 ? (
                    <GreyBody>No details available.</GreyBody>
                ) : (
                    <>
                        <Tabs
                            value={safeIndex}
                            onChange={(_, next) => setTabIndex(next)}
                            textColor="primary"
                            indicatorColor="primary"
                            css={css`
                                margin-bottom: 1rem;
                            `}
                        >
                            {tabs.map((t) => (
                                <Tab key={t.key} label={t.label} />
                            ))}
                        </Tabs>
                        {ActiveComponent ? <ActiveComponent clientId={clientId} context={context} /> : null}
                    </>
                )}
            </ModalContent>
        </NavResponsiveModal>
    );
};

export default AccountDetailsModal;
